import React, { useEffect } from "react";
const GoogleTranslate = () => {
  useEffect(() => {
    const addScript = () => {
      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    if (!document.querySelector('script[src*="translate.google.com"]')) {
      addScript();
    }
  }, []);

  return (
    <>
      <style>{`
        /* Hide Google top bar */
        .goog-te-banner-frame.skiptranslate {
          display: none !important;
        }

        body {
          top: 0 !important;
        }

        /* Remove default UI */
        .goog-te-gadget {
          font-size: 0 !important;
          background: transparent !important;
          border: none !important;
        }

        .goog-te-gadget img,
        .goog-te-gadget span {
          display: none !important;
        }

        /* Invisible dropdown but clickable */
        .goog-te-combo {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
          border: none !important;
          background: transparent !important;
        }

        /* Remove white container */
        #google_translate_element {
          position: absolute;
          inset: 0;
        }
      `}</style>

      {/* 🔥 Clean Navbar Icon */}
      <div className="relative flex items-center justify-center w-10 h-10 mx-2 cursor-pointer">
        
        {/* Google Translate SVG Icon */}
        <svg
          width="30"
          height="30"
          viewBox="0 0 48 48"
          className="block"
        >
          <path fill="#4285F4" d="M24 4H8C6.9 4 6 4.9 6 6V30C6 31.1 6.9 32 8 32H24L30 38V6C30 4.9 29.1 4 28 4H24Z"/>
          <path fill="#34A853" d="M42 14H26V38L32 44V16C32 14.9 32.9 14 34 14H42Z"/>
          <text x="12" y="22" fontSize="12" fill="white" fontWeight="bold">G</text>
          <text x="30" y="30" fontSize="12" fill="white">文</text>
        </svg>

        {/* Hidden Google Translate */}
        <div id="google_translate_element"></div>
      </div>
    </>
  );
};

export default GoogleTranslate;